// extracted by mini-css-extract-plugin
export default {"SignoutButton":"styles_SignoutButton__WZ9ny"};